import { Link as RouterLink } from 'react-router-dom';

// material-ui
import Link from '@mui/material/Link';

// project imports
// ZERCODE CHANGE (LAND-CFG): logo, sabit DASHBOARD_PATH yerine kiracının AÇILIŞ SAYFASI ayarına
// gider — girişte işleyen ayarın logoda yok sayılması tutarsızlıktı. Hedefi çözen hook, giriş
// yönlendirmesini (LandingRedirect) süren hook'un TA KENDİSİ.
import { LANDING_FALLBACK, useLandingRoute } from '../../../../lib/useLandingRoute';
import Logo from 'ui-component/Logo';

// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection() {
  // İzinler gelene kadar hook `null` der; link o an SPA'nın sabit varsayılanını gösterir
  // (bir link tıklanana kadar hiçbir yere gitmez, ve izinler ilk boyamadan hemen sonra yerleşir).
  const landing = useLandingRoute();

  return (
    // ⚠ `display: block` + `minWidth: 0` SO THE LOGO CAN SHRINK. An <a> is inline by default, and an
    // inline box between a flex container and the image blocks the shrinking the header row depends on
    // at 375px (see Header/index.tsx, where the 52px of slack is measured). `lineHeight: 0` because an
    // inline formatting context reserves room for a text baseline under the image — a few phantom pixels
    // that the AppBar, being as tall as its contents, would otherwise inherit.
    <Link
      component={RouterLink}
      to={landing ?? LANDING_FALLBACK}
      aria-label="theme-logo"
      sx={{ display: 'block', minWidth: 0, lineHeight: 0 }}
    >
      <Logo />
    </Link>
  );
}
